module.exports = __webpack_public_path__ + "img/bg_avatar_male_54.25db1d83.png";